import React, { FC } from 'react';
import styled from 'styled-components';
import { Black1, White } from '../../styles/colours';
import { DemiBold } from '../../styles/fonts';
import { ProductSearchDropdown } from './product-search/product-search-dropdown';
import { QuantitySearch } from './quantity-search/quantity-search';
import { ShipToSearchDropdown } from './ship-to-search/ship-to-customer-search';

const StyledSearchHeading = styled.div`
  padding: 0rem 0rem 2rem 0rem;
  font-size: 1.5rem;
  font-family: ${DemiBold};
  color: ${Black1};
`;

const StyledSearchSection = styled.section`
  @media print {
    display: none;
  }
`;

const StyledSearches = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  align-items: center;
  background: ${White};
  padding: 1rem 1rem 1rem 2rem;
  margin-bottom: 2rem;
  border-radius: 0.25rem;
`;

export const OrderSimulationSearchControls: FC<{
  soldToId: string;
  shipToId: string;
  productId: string;
  quantity: string;
  salesOrg: string;
}> = ({ soldToId, shipToId, productId, quantity, salesOrg }) => {
  return (
    <StyledSearchSection>
      <StyledSearchHeading>Enter your search</StyledSearchHeading>
      <StyledSearches>
        <ShipToSearchDropdown
          soldToId={soldToId}
          productId={productId}
          quantity={quantity}
        />
        <ProductSearchDropdown
          soldToId={soldToId}
          shipToId={shipToId}
          quantity={quantity}
          salesOrg={salesOrg}
        />
        <QuantitySearch
          soldToId={soldToId}
          shipToId={shipToId}
          productId={productId}
        />
      </StyledSearches>
    </StyledSearchSection>
  );
};
